import { CalendarCheck, CheckCircle, Key, UserCirclePlus, UsersThree } from '@phosphor-icons/react';
import { formatDistanceToNow } from 'date-fns';
import { cn } from '@/lib/utils/cn';
import type { ActivityEvent } from '@/lib/dashboard/useDashboardAnalytics';

const ICON_MAP = {
  interview_scheduled: CalendarCheck,
  interview_completed: CheckCircle,
  license_activated: Key,
  candidate_added: UserCirclePlus,
  employee_joined: UsersThree,
} as const;

const ACCENT_CLASSES = {
  electric: 'bg-neurax-electric/10 text-neurax-electric',
  plasma: 'bg-neurax-plasma/10 text-neurax-plasma',
  amber: 'bg-neurax-amber/10 text-neurax-amber',
  mint: 'bg-neurax-mint/10 text-neurax-mint',
} as const;

export function ActivityFeedItem({ event }: { event: ActivityEvent }) {
  const Icon = ICON_MAP[event.type];
  const relative = formatDistanceToNow(new Date(event.timestamp), { addSuffix: true });

  return (
    <div className="flex items-start gap-3 px-4 py-3.5">
      <div
        className={cn(
          'grid h-9 w-9 shrink-0 place-items-center rounded-xl',
          ACCENT_CLASSES[event.accent]
        )}
      >
        <Icon size={18} weight="duotone" />
      </div>

      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-white">{event.title}</p>
        <p className="mt-0.5 truncate text-xs text-muted-foreground">{event.description}</p>
      </div>

      <span className="shrink-0 text-[11px] text-muted-foreground">{relative}</span>
    </div>
  );
}
